import { ActivityIndicator, ScrollView } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { View, Text, ScreenContainer } from "@src/components";
import { NotificationPreferencesForm } from "@visioni/a3s-notifications/app";
import { useNotificationPreferencesPage } from "@src/features/settings/hooks";

export default function NotificationPreferencesScreen() {
  const { theme } = useUnistyles();
  const {
    isNotificationSettingsEnabled,
    isLoading,
    isError,
    allCameras,
    sites,
    cameras,
    onToggleAllCamerasChannel,
    onToggleSiteChannel,
    onToggleCameraChannel,
    phoneNumber,
    onSavePhoneNumber,
  } = useNotificationPreferencesPage();

  if (!isNotificationSettingsEnabled) {
    return null;
  }

  return (
    <ScreenContainer edges={["bottom"]}>
      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={{ paddingHorizontal: theme.spacing["5xl"], paddingTop: theme.spacing["4xl"] }}
      >
        {isLoading ?
          <View py="4xl" alignItems="center">
            <ActivityIndicator color={theme.colors.text as string} />
          </View>
        : isError ?
          <View py="4xl" alignItems="center">
            <Text textStyle="sm/regular" color="textMuted">
              {"Couldn't load your notification preferences. Please try again."}
            </Text>
          </View>
        : <NotificationPreferencesForm
            allCameras={allCameras}
            onToggleAllCamerasChannel={onToggleAllCamerasChannel}
            sites={sites}
            onToggleSiteChannel={onToggleSiteChannel}
            cameras={cameras}
            onToggleCameraChannel={onToggleCameraChannel}
            phoneNumber={phoneNumber}
            onSavePhoneNumber={onSavePhoneNumber}
          />
        }
      </ScrollView>
    </ScreenContainer>
  );
}
